export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5348.198d0e38.jpg";